import { useDashboardContext } from '../context/DashboardProvider';
import { DashboardCategories } from '../enums';

export function useCategoryVisibility(categoryKey: DashboardCategories): boolean {
  const { activeCategory } = useDashboardContext();
  return activeCategory === categoryKey;
}
